import { render, staticRenderFns } from "./page5.vue?vue&type=template&id=3ae920e9&scoped=true"
import script from "./page5.vue?vue&type=script&lang=js"
export * from "./page5.vue?vue&type=script&lang=js"
import style0 from "./page5.vue?vue&type=style&index=0&id=3ae920e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae920e9",
  null
  
)

export default component.exports